import { copyListFormStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsCopyListForm";
import { css } from "styled-components";

copyListFormStyles.cancelButton = {
    mergeCss:true,
    color: "secondary",
    css: css`
        margin-right: 10px;
    `,
}

copyListFormStyles.wishListDynamicDropdown = {
    cssOverrides:{
        list:css`
            background: #FFFFFF !important;            
        `,
    }
}